export default __webpack_public_path__ + "static/media/AirFares.343238aa.svg";